<template>
  <div>
    <div v-if="showPaySuccess">
      <ShopSteps v-if="paramMapAll['SHOP_GOODS_ORDER_NEED_ADDRESS']==='1'||$route.query.needAddress" :step="5" />
      <div id="addToCart-modal-body">
        <div class="modal-body p-4 added-to-cart" style="max-height: 90vh">
          <div class="text-center text-success mb-4">
            <i class="las la-check-circle la-3x"></i>
            <h3>{{ $t("购买成功提示") }}！</h3>
          </div>
          <div class="text-center">
            <button
              class="btn btn-outline-primary mb-3 mb-sm-0 mr-3"
              @click="goto('/')"
            >
              {{ $t("返回购物") }}
            </button>
            <router-link
              class="btn btn-primary mb-3 mb-sm-0"
              to="/user/purchase_history"
              >{{ $t("订单列表") }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <ShopSteps v-if="paramMapAll['SHOP_GOODS_ORDER_NEED_ADDRESS']==='1'||$route.query.needAddress" :step="4" />
      <section class="mb-4">
        <div class="container text-left">
          <div class="row">
            <div class="col-lg-8">
              <div class="card rounded border-0 shadow-sm">
                <div class="card-header p-3">
                  <h3 class="fs-16 fw-600 mb-0">
                    {{ $t("任何其他信息") + "？" }}
                  </h3>
                </div>
                <div class="form-group px-3 pt-3">
                  <textarea
                    :placeholder="$t('输入您的文字')"
                    class="form-control"
                    name="additional_info"
                    rows="5"
                  ></textarea>
                </div>
                <div class="d-none mb-3 rounded border bg-white p-3 text-left">
                  <div id="manual_payment_description"></div>
                </div>
                <div class="separator mb-3">
                  <span class="bg-white px-3">
                    <span class="opacity-60">{{ $t("或者") }}</span>
                  </span>
                </div>
                <div class="py-4 text-center">
                  <div class="h6 mb-3">
                    <span class="opacity-80">{{
                      $t("您的钱包余额") + ":"
                    }}</span
                    >&nbsp;
                    <span class="fw-600">{{
                      formatMoney(userMoney.balance, currency, true)
                    }}</span>
                  </div>
                  <div
                    v-if="dealMoney(userMoney.balance, currency, true) < userCartTotalPrice"
                    class="d-inline-flex"
                  >
                    <button
                      class="btn btn-secondary mr-3"
                      disabled=""
                      type="button"
                    >
                      {{ $t("余额不足") }}
                    </button>
                    <router-link class="btn btn-primary" to="/user/wallet">
                      {{ $t("前往充值") }}
                    </router-link>
                  </div>
                  <template v-else>
                    <div class="text-center" v-if="userInfo.tkPasswordHasFlag">
                      <zfield
                          class="form-control"
                          v-model="tkPassword"
                          :placeholder="$t('提款密码')"
                          name="password"
                          type="password"
                          style="width: 200px;margin: 8px auto;"
                      />
                    </div>
                    <van-button
                      :loading="loading"
                      class="btn btn-primary"
                      type="button"
                      @click="pay"
                    >
                      {{ $t("支付") }}
                    </van-button>
                  </template>
                </div>
              </div>
              <div class="pt-3">
                <label class="aiz-checkbox">
                  <input
                    id="agree_checkbox"
                    checked=""
                    required=""
                    type="checkbox"
                  />
                  <span class="aiz-square-check"></span>
                  <span>{{ $t("我同意") }}</span>
                </label>
                &nbsp;
                <router-link :to="`/terms?code=${ARTICLE_TERM_ID()}`"
                  >{{ $t("条款和条件") }}
                </router-link>
                ,
                <router-link :to="`/terms?code=${ARTICLE_RETURN_ID()}`"
                  >{{ $t("退货政策") }}
                </router-link>
                &amp;
                <router-link :to="`/terms?code=${ARTICLE_PRIVACY_ID()}`"
                  >{{ $t("隐私政策") }}
                </router-link>
              </div>

              <div class="row align-items-center pt-3">
                <div class="col-6">
                  <router-link class="link link--style-3" to="/">
                    <i class="las la-arrow-left"></i>
                    {{ $t("返回商店") }}
                  </router-link>
                </div>
              </div>
            </div>

            <div id="cart_summary" class="col-lg-4 mt-lg-0 mt-4">
              <div class="card rounded border-0 shadow-sm">
                <div class="card-header">
                  <h3 class="fs-16 fw-600 mb-0">{{ $t("概括") }}</h3>
                  <div class="text-right">
                    <span class="badge badge-inline badge-primary">
                      {{ userCartItemCount }} {{ $t("项目") }}
                    </span>
                  </div>
                </div>

                <div class="card-body">
                  <template v-for="(item0, index) in userCart">
                    <table :key="index" class="table">
                      <thead>
                        <tr>
                          <th class="product-name">{{ $t(item0.name) }}</th>
                          <th class="product-total text-right">
                            {{ $t("合计") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in item0.carts"
                          :key="index"
                          class="cart_item"
                        >
                          <td class="product-name">
                            <div>
                              {{ item.goodsName }}
                              <span
                                v-if="isValidateSpec(item.goodsSpecName)"
                                class="text-secondary"
                                >{{ item.goodsSpecName }}</span
                              >
                            </div>
                          </td>
                          <td class="product-total text-right">
                            <div class="pl-4 pr-0">
                              {{ formatMoney(priceDiscount(item0, item)) }}
                            </div>
                            <div>
                              <strong class="product-quantity">
                                × {{ item.number }}
                              </strong>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </template>
                  <table class="table">
                    <tfoot>
                      <tr class="cart-subtotal">
                        <th>{{ $t("小计") }}</th>
                        <td class="text-right">
                          <span class="fw-600">{{
                            formatMoney(userCartTotalPrice)
                          }}</span>
                        </td>
                      </tr>

                      <tr class="cart-shipping">
                        <th>{{ $t("税") }}</th>
                        <td class="text-right">
                          <span class="font-italic">{{ formatMoney(0) }}</span>
                        </td>
                      </tr>

                      <tr class="cart-shipping">
                        <th>{{ $t("总运费") }}</th>
                        <td class="text-right">
                          <span class="font-italic">{{ formatMoney(0) }}</span>
                        </td>
                      </tr>

                      <tr class="cart-total">
                        <th>
                          <span class="strong-600">{{ $t("全部的") }}</span>
                        </th>
                        <td class="text-right">
                          <strong
                            ><span>{{
                              formatMoney(userCartTotalPrice)
                            }}</span></strong
                          >
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="request_modal"
          aria-hidden="true"
          aria-labelledby="exampleModalLabel"
          class="modal fade"
          role="dialog"
          tabindex="-1"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 id="exampleModalLabel" class="modal-title">
                  {{ $t("Transaction Password") }}
                </h5>
                <button
                  aria-label="Close"
                  class="close"
                  data-dismiss="modal"
                  type="button"
                ></button>
              </div>

              <div class="modal-body gry-bg px-3 pt-3">
                <div class="row">
                  <div class="col-md-9">
                    <input
                      id="tpwd"
                      :placeholder="$t('Transaction Password')"
                      class="form-control mb-3"
                      lang="en"
                      max="6"
                      name="tpwd"
                      required=""
                      type="password"
                    />
                  </div>
                </div>
                <div class="form-group text-right">
                  <button
                    class="btn btn-sm btn-primary"
                    onclick="check_pwd()"
                    type="button"
                  >
                    {{ $t("Submit") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { pay } from "@/api/user.cart";
import ShopSteps from "@/components/ShopSteps.vue";
import {
  ARTICLE_PRIVACY_ID,
  ARTICLE_RETURN_ID,
  ARTICLE_TERM_ID
} from "@/constant/constant";

export default {
  name: "checkoiutPayment",
  components: { ShopSteps },
  async beforeRouteEnter(to, from, next) {
     // await store.dispatch('common/dictListComputeIfAbsent','sysStaffPosition')
     next((vm) => {
       console.log('checkoiutPayment watch', arguments)
          if (vm.userInfo && vm.userInfo.id) {
            vm.$store.dispatch("user/getUserMoney")
          }
       // access to component public instance via `vm`
     })
   },
  data() {
    return {
      showPaySuccess: false,
      loading: false,
      tkPassword: null,
    };
  },
  watch: {
    // '$route'() {
    //
    // }
  },
  methods: {
    priceDiscount(shop, goods) {
      if (!shop.isSeckillShop) return goods.price
      let buyDiscount = goods && goods.buyDiscount || 100;
      return goods && goods.price * buyDiscount / 100
    },
    ARTICLE_PRIVACY_ID() {
      return ARTICLE_PRIVACY_ID;
    },
    ARTICLE_RETURN_ID() {
      return ARTICLE_RETURN_ID;
    },
    ARTICLE_TERM_ID() {
      return ARTICLE_TERM_ID;
    },
    pay() {
      this.loading = true;
      const tkPassword = this.tkPassword;
      const list = this.$route.query.buyNow ? JSON.parse(decodeURIComponent(Cookies.get('buyNowData'))) : this.userCart.flatMap(shop => shop.carts);
      console.log('this.$route.query.buyNow',this.$route.query.buyNow)
      console.log('Cookies.get(\'buyNowData\')',decodeURIComponent(Cookies.get('buyNowData')))
      console.log('list',list)
      const addressId = Cookies.get("checkout_addressId");
      // const addressId = this.$route.query.addressId;
      pay({
        list: list,
        addressId,
        tkPassword,
      })
        .then(() => {
          this.$store.commit("user/SET_USER_CART", []); // 下单之后清空本地购物车缓存信息
          Cookies.remove("checkout_addressId");
          let path = this.paramMapAll["SHOP_PAY_SUCCESS_PATH"];
          if (this.isMobile && path) {
            this.$router.push({path});
          } else {
            this.showPaySuccess = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
